import { render, staticRenderFns } from "./WebLinkTtcGroups.vue?vue&type=template&id=e65acf64&scoped=true&"
import script from "./WebLinkTtcGroups.vue?vue&type=script&lang=js&"
export * from "./WebLinkTtcGroups.vue?vue&type=script&lang=js&"
import style0 from "./WebLinkTtcGroups.vue?vue&type=style&index=0&id=e65acf64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e65acf64",
  null
  
)

export default component.exports